<div class="full-screen">
    <div class="content" *ngIf="isMaintenance()">
        <h2>{{ getMaintenanceTitle() }}</h2>
        <p>{{ getMaintenanceMessage() }}</p>
    </div>
</div>
